import { WorkforceHealthMetrics } from "@acumen/database-types";

export const colorVariants: Partial<Record<WorkforceHealthMetrics, string>> = {
	[WorkforceHealthMetrics.AveragePRCodingTime]: "#2278F3",
	[WorkforceHealthMetrics.AveragePRPendingReviewTime]: "#32B195",
	[WorkforceHealthMetrics.AveragePRReviewTime]: "#925EFF",
	[WorkforceHealthMetrics.AveragePRPendingMergeTime]: "#FFBB36",
};
